/** Normalize API payloads (unknown shape) into DataGrid rows. */
export function normalizeToRows(data: unknown): Record<string, unknown>[] {
  if (data == null) return [];
  if (Array.isArray(data)) {
    return data.filter((r) => r != null && typeof r === 'object') as Record<string, unknown>[];
  }
  if (typeof data === 'object') {
    const o = data as Record<string, unknown>;
    for (const key of ['items', 'rows', 'data', 'results', 'records']) {
      if (Array.isArray(o[key])) return normalizeToRows(o[key]);
    }
    return [o];
  }
  return [{ value: data }];
}

export interface GridColumnDef {
  dataField: string;
  caption: string;
}

/** Build columns from the first rows' keys. */
export function columnsFromRows(rows: Record<string, unknown>[]): GridColumnDef[] {
  if (!rows.length) return [];
  const keys = new Set<string>();
  for (const row of rows.slice(0, 100)) {
    Object.keys(row).forEach((k) => keys.add(k));
  }
  return [...keys].map((dataField) => ({ dataField, caption: dataField }));
}
